import React from 'react';
import { BrowserRouter } from 'react-router';

import { QueryClientProvider } from '@tanstack/react-query';
import theme from 'theme';
import { ThemeProvider } from '@mui/material/styles';
import Routes from 'Routes';
import { CssBaseline } from '@mui/material';
import { ModalManager } from 'components/Common/ModalManager';
import 'i18n/i18n';
import { LicenseInfo } from '@mui/x-date-pickers-pro';
import { switchTheme } from 'theme/themeSwitch';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import { useDebug } from 'hooks/useDebug';
import { useUserBootstrap } from 'hooks/useUserBootstrap';
import { Drawer } from 'views/Drawer/Drawer';
import { queryClient } from 'hooks/queries/queryClient';
import { HostProvider } from 'contexts/Host';

LicenseInfo.setLicenseKey(
  '930adedbef2298fdf58cbdcdf6469be5Tz04MDg3OCxFPTE3MzQ2OTE0NjgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
);

export default function App() {
  useDebug();
  useUserBootstrap();

  const runtimeConfig = useRuntimeConfig();
  switchTheme(runtimeConfig.configData);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <HostProvider>
            <ModalManager />
            <Drawer />
            <Routes />
          </HostProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
